export default "__VITE_ASSET__mp3G2Ax5__"